export const FIELDNAMES = {
  CargoId: "Yük id",
  Cargo2Id: "Cargo2Id",
  CustomerId: "Müştəri id",
  NetDate: "Net tarix",
  OperationDate: "Əməliyyat tarixi",
  SenderId: "Göndərən id",
  TruckId: "Avtomobil id",
  TruckOwnerId: "TruckOwnerId",
  Weight1: "Çəki - 1",
  Weight2: "Çəki - 2",
  Weight1Note: "Çəki 1 qeyd",
  Weight2Note: "Çəki 1 qeyd",
  WeightNet: "Net çəki",
  StatusNote: "StatusNote",
  CustomerBranchId: "CustomerBranchId",
  SenderBranchId: "SenderBranchId",
  CustomerWarehouseId: "CustomerBranchId",
  SenderWarehouseId: "SenderBranchId",
  Trailer: "Trailer",
  OperationTypeId: 'Əməliyyat növü',
};

// auth
export const AUTH_LOGIN_REQUEST = "AUTH_LOGIN_REQUEST";
export const AUTH_LOGIN_SUCCESS = "AUTH_LOGIN_SUCCESS";
export const AUTH_LOGIN_SCALE_MODAL_CLOSE = "AUTH_LOGIN_SCALE_MODAL_CLOSE";
export const AUTH_LOGIN_SCALE_MODAL_SUCCESS = "AUTH_LOGIN_SCALE_MODAL_SUCCESS";
export const AUTH_LOGIN_FAIL = "AUTH_LOGIN_FAIL";

export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_LOGOUT_SUCCESS = "AUTH_LOGOUT_SUCCESS";
export const AUTH_LOGOUT_FAIL = "AUTH_LOGOUT_FAIL";

// customer
export const GET_CUSTOMER_LIST = "GET_CUSTOMER_LIST";
export const GET_CUSTOMER_LIST_SUCCESS = "GET_CUSTOMER_LIST_SUCCESS";
export const GET_CUSTOMER_LIST_FAIL = "GET_CUSTOMER_LIST_FAIL";

export const DELETE_CUSTOMER_REQUEST = "DELETE_CUSTOMER_REQUEST";
export const DELETE_CUSTOMER_SUCCESS = "DELETE_CUSTOMER_SUCCESS";
export const DELETE_CUSTOMER_FAIL = "DELETE_CUSTOMER_FAIL";

export const ADD_CUSTOMER_REQUEST = "ADD_CUSTOMER_REQUEST";
export const ADD_CUSTOMER_SUCCESS = "ADD_CUSTOMER_SUCCESS";
export const ADD_CUSTOMER_FAIL = "ADD_CUSTOMER_FAIL";

export const GET_SINGLE_CUSTOMER = "GET_SINGLE_CUSTOMER";
export const GET_SINGLE_CUSTOMER_SUCCESS = "GET_SINGLE_CUSTOMER_SUCCESS";
export const GET_SINGLE_CUSTOMER_FAIL = "GET_SINGLE_CUSTOMER_FAIL";

export const UPDATE_CUSTOMER_REQUEST = "UPDATE_CUSTOMER_REQUEST";
export const UPDATE_CUSTOMER_SUCCESS = "UPDATE_CUSTOMER_SUCCESS";
export const UPDATE_CUSTOMER_FAIL = "UPDATE_CUSTOMER_FAIL";

export const GET_CUSTOMER_BRANCH_LIST_REQUEST = "GET_CUSTOMER_BRANCH_LIST";
export const GET_CUSTOMER_BRANCH_LIST_SUCCESS =
  "GET_CUSTOMER_BRANCH_LIST_SUCCESS";
export const GET_CUSTOMER_BRANCH_LIST_FAIL = "GET_CUSTOMER_BRANCH_LIST_FAIL";

export const DELETE_CUSTOMER_BRANCH_REQUEST = "DELETE_CUSTOMER_BRANCH_REQUEST";
export const DELETE_CUSTOMER_BRANCH_SUCCESS = "DELETE_CUSTOMER_BRANCH_SUCCESS";
export const DELETE_CUSTOMER_BRANCH_FAIL = "DELETE_CUSTOMER_BRANCH_FAIL";

export const ADD_CUSTOMER_BRANCH_REQUEST = "ADD_CUSTOMER_BRANCH_REQUEST";
export const ADD_CUSTOMER_BRANCH_SUCCESS = "ADD_CUSTOMER_BRANCH_SUCCESS";
export const ADD_CUSTOMER_BRANCH_FAIL = "ADD_CUSTOMER_BRANCH_FAIL";

export const GET_SINGLE_CUSTOMER_BRANCH_REQUEST = "GET_SINGLE_CUSTOMER_BRANCH";
export const GET_SINGLE_CUSTOMER_BRANCH_SUCCESS =
  "GET_SINGLE_CUSTOMER_BRANCH_SUCCESS";
export const GET_SINGLE_CUSTOMER_BRANCH_FAIL =
  "GET_SINGLE_CUSTOMER_BRANCH_FAIL";

export const UPDATE_CUSTOMER_BRANCH_REQUEST = "UPDATE_CUSTOMER_BRANCH_REQUEST";
export const UPDATE_CUSTOMER_BRANCH_SUCCESS = "UPDATE_CUSTOMER_BRANCH_SUCCESS";
export const UPDATE_CUSTOMER_BRANCH_FAIL = "UPDATE_CUSTOMER_BRANCH_FAIL";

export const GET_CUSTOMER_WAREHOUSE_LIST_REQUEST =
  "GET_CUSTOMER_WAREHOUSE_LIST";
export const GET_CUSTOMER_WAREHOUSE_LIST_SUCCESS =
  "GET_CUSTOMER_WAREHOUSE_LIST_SUCCESS";
export const GET_CUSTOMER_WAREHOUSE_LIST_FAIL =
  "GET_CUSTOMER_WAREHOUSE_LIST_FAIL";

export const DELETE_CUSTOMER_WAREHOUSE_REQUEST =
  "DELETE_CUSTOMER_WAREHOUSE_REQUEST";
export const DELETE_CUSTOMER_WAREHOUSE_SUCCESS =
  "DELETE_CUSTOMER_WAREHOUSE_SUCCESS";
export const DELETE_CUSTOMER_WAREHOUSE_FAIL = "DELETE_CUSTOMER_WAREHOUSE_FAIL";

export const ADD_CUSTOMER_WAREHOUSE_REQUEST = "ADD_CUSTOMER_WAREHOUSE_REQUEST";
export const ADD_CUSTOMER_WAREHOUSE_SUCCESS = "ADD_CUSTOMER_WAREHOUSE_SUCCESS";
export const ADD_CUSTOMER_WAREHOUSE_FAIL = "ADD_CUSTOMER_WAREHOUSE_FAIL";

export const GET_SINGLE_CUSTOMER_WAREHOUSE_REQUEST =
  "GET_SINGLE_CUSTOMER_WAREHOUSE";
export const GET_SINGLE_CUSTOMER_WAREHOUSE_SUCCESS =
  "GET_SINGLE_CUSTOMER_WAREHOUSE_SUCCESS";
export const GET_SINGLE_CUSTOMER_WAREHOUSE_FAIL =
  "GET_SINGLE_CUSTOMER_WAREHOUSE_FAIL";

export const UPDATE_CUSTOMER_WAREHOUSE_REQUEST =
  "UPDATE_CUSTOMER_WAREHOUSE_REQUEST";
export const UPDATE_CUSTOMER_WAREHOUSE_SUCCESS =
  "UPDATE_CUSTOMER_WAREHOUSE_SUCCESS";
export const UPDATE_CUSTOMER_WAREHOUSE_FAIL = "UPDATE_CUSTOMER_WAREHOUSE_FAIL";

export const GET_SENDER_WAREHOUSE_LIST_REQUEST = "GET_SENDER_WAREHOUSE_LIST";
export const GET_SENDER_WAREHOUSE_LIST_SUCCESS =
  "GET_SENDER_WAREHOUSE_LIST_SUCCESS";
export const GET_SENDER_WAREHOUSE_LIST_FAIL = "GET_SENDER_WAREHOUSE_LIST_FAIL";

export const DELETE_SENDER_WAREHOUSE_REQUEST =
  "DELETE_SENDER_WAREHOUSE_REQUEST";
export const DELETE_SENDER_WAREHOUSE_SUCCESS =
  "DELETE_SENDER_WAREHOUSE_SUCCESS";
export const DELETE_SENDER_WAREHOUSE_FAIL = "DELETE_SENDER_WAREHOUSE_FAIL";

export const ADD_SENDER_WAREHOUSE_REQUEST = "ADD_SENDER_WAREHOUSE_REQUEST";
export const ADD_SENDER_WAREHOUSE_SUCCESS = "ADD_SENDER_WAREHOUSE_SUCCESS";
export const ADD_SENDER_WAREHOUSE_FAIL = "ADD_SENDER_WAREHOUSE_FAIL";

export const GET_SINGLE_SENDER_WAREHOUSE_REQUEST =
  "GET_SINGLE_SENDER_WAREHOUSE";
export const GET_SINGLE_SENDER_WAREHOUSE_SUCCESS =
  "GET_SINGLE_SENDER_WAREHOUSE_SUCCESS";
export const GET_SINGLE_SENDER_WAREHOUSE_FAIL =
  "GET_SINGLE_SENDER_WAREHOUSE_FAIL";

export const UPDATE_SENDER_WAREHOUSE_REQUEST =
  "UPDATE_SENDER_WAREHOUSE_REQUEST";
export const UPDATE_SENDER_WAREHOUSE_SUCCESS =
  "UPDATE_SENDER_WAREHOUSE_SUCCESS";
export const UPDATE_SENDER_WAREHOUSE_FAIL = "UPDATE_SENDER_WAREHOUSE_FAIL";

// OrderPartStepCompany
export const GET_ORDER_PART_STEP_COMPANY_LIST_REQUEST =
  "GET_ORDER_PART_STEP_COMPANY_LIST_REQUEST";
export const GET_ORDER_PART_STEP_COMPANY_LIST_SUCCESS =
  "GET_ORDER_PART_STEP_COMPANY_LIST_SUCCESS";
export const GET_ORDER_PART_STEP_COMPANY_LIST_FAIL =
  "GET_ORDER_PART_STEP_COMPANY_LIST_FAIL";

export const GET_SINGLE_ORDER_PART_STEP_COMPANY_REQUEST =
  "GET_SINGLE_ORDER_PART_STEP_COMPANY_REQUEST";
export const GET_SINGLE_ORDER_PART_STEP_COMPANY_SUCCESS =
  "GET_SINGLE_ORDER_PART_STEP_COMPANY_SUCCESS";
export const GET_SINGLE_ORDER_PART_STEP_COMPANY_FAIL =
  "GET_SINGLE_ORDER_PART_STEP_COMPANY_FAIL";

export const ADD_ORDER_PART_STEP_COMPANY_REQUEST =
  "ADD_ORDER_PART_STEP_COMPANY_REQUEST";
export const ADD_ORDER_PART_STEP_COMPANY_SUCCESS =
  "ADD_ORDER_PART_STEP_COMPANY_SUCCESS";
export const ADD_ORDER_PART_STEP_COMPANY_FAIL =
  "ADD_ORDER_PART_STEP_COMPANY_FAIL";

export const UPDATE_ORDER_PART_STEP_COMPANY_REQUEST =
  "UPDATE_ORDER_PART_STEP_COMPANY_REQUEST";
export const UPDATE_ORDER_PART_STEP_COMPANY_SUCCESS =
  "UPDATE_ORDER_PART_STEP_COMPANY_SUCCESS";
export const UPDATE_ORDER_PART_STEP_COMPANY_FAIL =
  "UPDATE_ORDER_PART_STEP_COMPANY_FAIL";

export const DELETE_ORDER_PART_STEP_COMPANY_REQUEST =
  "DELETE_ORDER_PART_STEP_COMPANY_REQUEST";
export const DELETE_ORDER_PART_STEP_COMPANY_SUCCESS =
  "DELETE_ORDER_PART_STEP_COMPANY_SUCCESS";
export const DELETE_ORDER_PART_STEP_COMPANY_FAIL =
  "DELETE_ORDER_PART_STEP_COMPANY_FAIL";

// cargo
export const GET_CARGO2_LIST = "GET_CARGO2_LIST";
export const GET_CARGO2_LIST_SUCCESS = "GET_CARGO2_LIST_SUCCESS";
export const GET_CARGO2_LIST_FAIL = "GET_CARGO2_LIST_FAIL";

export const GET_CARGO_LIST = "GET_CARGO_LIST";
export const GET_CARGO_LIST_SUCCESS = "GET_CARGO_LIST_SUCCESS";
export const GET_CARGO_LIST_FAIL = "GET_CARGO_LIST_FAIL";

export const GET_SINGLE_CARGO = "GET_SINGLE_CARGO";
export const GET_SINGLE_CARGO_SUCCESS = "GET_SINGLE_CARGO_SUCCESS";
export const GET_SINGLE_CARGO_FAIL = "GET_SINGLE_CARGO_FAIL";

export const ADD_CARGO_REQUEST = "ADD_CARGO_REQUEST";
export const ADD_CARGO_SUCCESS = "ADD_CARGO_SUCCESS";
export const ADD_CARGO_FAIL = "ADD_CARGO_FAIL";

export const UPDATE_CARGO_REQUEST = "UPDATE_CARGO_REQUEST";
export const UPDATE_CARGO_SUCCESS = "UPDATE_CARGO_SUCCESS";
export const UPDATE_CARGO_FAIL = "UPDATE_CARGO_FAIL";

export const DELETE_CARGO_REQUEST = "DELETE_CARGO_REQUEST";
export const DELETE_CARGO_SUCCESS = "DELETE_CARGO_SUCCESS";
export const DELETE_CARGO_FAIL = "DELETE_CARGO_FAIL";

// CargoMain
export const GET_CARGO_MAIN_LIST = "GET_CARGO_MAIN_LIST";
export const GET_CARGO_MAIN_LIST_SUCCESS = "GET_CARGO_MAIN_LIST_SUCCESS";
export const GET_CARGO_MAIN_LIST_FAIL = "GET_CARGO_MAIN_LIST_FAIL";

export const GET_SINGLE_CARGO_MAIN = "GET_SINGLE_CARGO_MAIN";
export const GET_SINGLE_CARGO_MAIN_SUCCESS = "GET_SINGLE_CARGO_MAIN_SUCCESS";
export const GET_SINGLE_CARGO_MAIN_FAIL = "GET_SINGLE_CARGO_MAIN_FAIL";

export const ADD_CARGO_MAIN_REQUEST = "ADD_CARGO_MAIN_REQUEST";
export const ADD_CARGO_MAIN_SUCCESS = "ADD_CARGO_MAIN_SUCCESS";
export const ADD_CARGO_MAIN_FAIL = "ADD_CARGO_MAIN_FAIL";

export const UPDATE_CARGO_MAIN_REQUEST = "UPDATE_CARGO_MAIN_REQUEST";
export const UPDATE_CARGO_MAIN_SUCCESS = "UPDATE_CARGO_MAIN_SUCCESS";
export const UPDATE_CARGO_MAIN_FAIL = "UPDATE_CARGO_MAIN_FAIL";

export const DELETE_CARGO_MAIN_REQUEST = "DELETE_CARGO_MAIN_REQUEST";
export const DELETE_CARGO_MAIN_SUCCESS = "DELETE_CARGO_MAIN_SUCCESS";
export const DELETE_CARGO_MAIN_FAIL = "DELETE_CARGO_MAIN_FAIL";

// CargoType
export const GET_CARGO_TYPE_LIST = "GET_CARGO_TYPE_LIST";
export const GET_CARGO_TYPE_LIST_SUCCESS = "GET_CARGO_TYPE_LIST_SUCCESS";
export const GET_CARGO_TYPE_LIST_FAIL = "GET_CARGO_TYPE_LIST_FAIL";

export const GET_SINGLE_CARGO_TYPE = "GET_SINGLE_CARGO_TYPE";
export const GET_SINGLE_CARGO_TYPE_SUCCESS = "GET_SINGLE_CARGO_TYPE_SUCCESS";
export const GET_SINGLE_CARGO_TYPE_FAIL = "GET_SINGLE_CARGO_TYPE_FAIL";

export const ADD_CARGO_TYPE_REQUEST = "ADD_CARGO_TYPE_REQUEST";
export const ADD_CARGO_TYPE_SUCCESS = "ADD_CARGO_TYPE_SUCCESS";
export const ADD_CARGO_TYPE_FAIL = "ADD_CARGO_TYPE_FAIL";

export const UPDATE_CARGO_TYPE_REQUEST = "UPDATE_CARGO_TYPE_REQUEST";
export const UPDATE_CARGO_TYPE_SUCCESS = "UPDATE_CARGO_TYPE_SUCCESS";
export const UPDATE_CARGO_TYPE_FAIL = "UPDATE_CARGO_TYPE_FAIL";

export const DELETE_CARGO_TYPE_REQUEST = "DELETE_CARGO_TYPE_REQUEST";
export const DELETE_CARGO_TYPE_SUCCESS = "DELETE_CARGO_TYPE_SUCCESS";
export const DELETE_CARGO_TYPE_FAIL = "DELETE_CARGO_TYPE_FAIL";

// DeliveryType
export const GET_DELIVERY_TYPE_LIST = "GET_DELIVERY_TYPE_LIST";
export const GET_DELIVERY_TYPE_LIST_SUCCESS = "GET_DELIVERY_TYPE_LIST_SUCCESS";
export const GET_DELIVERY_TYPE_LIST_FAIL = "GET_DELIVERY_TYPE_LIST_FAIL";

export const GET_SINGLE_DELIVERY_TYPE = "GET_SINGLE_DELIVERY_TYPE";
export const GET_SINGLE_DELIVERY_TYPE_SUCCESS =
  "GET_SINGLE_DELIVERY_TYPE_SUCCESS";
export const GET_SINGLE_DELIVERY_TYPE_FAIL = "GET_SINGLE_DELIVERY_TYPE_FAIL";

export const ADD_DELIVERY_TYPE_REQUEST = "ADD_DELIVERY_TYPE_REQUEST";
export const ADD_DELIVERY_TYPE_SUCCESS = "ADD_DELIVERY_TYPE_SUCCESS";
export const ADD_DELIVERY_TYPE_FAIL = "ADD_DELIVERY_TYPE_FAIL";

export const UPDATE_DELIVERY_TYPE_REQUEST = "UPDATE_DELIVERY_TYPE_REQUEST";
export const UPDATE_DELIVERY_TYPE_SUCCESS = "UPDATE_DELIVERY_TYPE_SUCCESS";
export const UPDATE_DELIVERY_TYPE_FAIL = "UPDATE_DELIVERY_TYPE_FAIL";

export const DELETE_DELIVERY_TYPE_REQUEST = "DELETE_DELIVERY_TYPE_REQUEST";
export const DELETE_DELIVERY_TYPE_SUCCESS = "DELETE_DELIVERY_TYPE_SUCCESS";
export const DELETE_DELIVERY_TYPE_FAIL = "DELETE_DELIVERY_TYPE_FAIL";

// users
export const GET_FILE_REQUEST = "GET_FILE_REQUEST";
export const GET_FILE_SUCCESS = "GET_FILE_SUCCESS";
export const GET_FILE_FAIL = "GET_FILE_FAIL";

export const EDIT_USER_INFO_REQUEST = "EDIT_USER_INFO_REQUEST";
export const EDIT_USER_INFO_SUCCESS = "EDIT_USER_INFO_SUCCESS";
export const EDIT_USER_INFO_FAIL = "EDIT_USER_INFO_FAIL";

export const GET_USERS_LIST = "GET_USERS_LIST";
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
export const GET_USERS_FAIL = "GET_USERS_FAIL";

export const GET_SINGLE_USER = "GET_SINGLE_USER";
export const GET_SINGLE_USER_SUCCESS = "GET_SINGLE_USER_SUCCESS";
export const GET_SINGLE_USER_FAIL = "GET_SINGLE_USER_FAIL";

export const DELETE_USER = "DELETE_USER";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_FAIL = "DELETE_USER_FAIL";

export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAIL = "CHANGE_PASSWORD_FAIL";

export const RESET_PASSWORD = "RESET_PASSWORD";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAIL = "RESET_PASSWORD_FAIL";

export const GET_USER_DETAILS_REQUEST = "GET_USER_DETAILS_REQUEST";
export const GET_USER_DETAILS_SUCCESS = "GET_USER_DETAILS_SUCCESS";
export const GET_USER_DETAILS_FAIL = "GET_USER_DETAILS_FAIL";

export const APPROVE_USER_REQUEST = "APPROVE_USER_REQUEST";
export const APPROVE_USER_SUCCESS = "APPROVE_USER_SUCCESS";
export const APPROVE_USER_FAIL = "APPROVE_USER_FAIL";

export const INVITE_USER_REQUEST = "INVITE_USER_REQUEST";
export const INVITE_USER_SUCCESS = "INVITE_USER_SUCCESS";
export const INVITE_USER_FAIL = "INVITE_USER_FAIL";

export const GET_USER_INVITE_REQUEST = "GET_USER_INVITE_REQUEST";
export const GET_USER_INVITE_SUCCESS = "GET_USER_INVITE_SUCCESS";
export const GET_USER_INVITE_FAIL = "GET_USER_INVITE_FAIL";

export const APPROVE_USER_INVITE_REQUEST = "APPROVE_USER_INVITE_REQUEST";
export const APPROVE_USER_INVITE_SUCCESS = "APPROVE_USER_INVITE_SUCCESS";
export const APPROVE_USER_INVITE_FAIL = "APPROVE_USER_INVITE_FAIL";

export const RESEND_APPROVE_MAIL_REQUEST = "RESEND_APPROVE_MAIL_REQUEST";
export const RESEND_APPROVE_MAIL_SUCCESS = "RESEND_APPROVE_MAIL_SUCCESS";
export const RESEND_APPROVE_MAIL_FAIL = "RESEND_APPROVE_MAIL_FAIL";

export const RESEND_INVITE_MAIL_REQUEST = "RESEND_INVITE_MAIL_REQUEST";
export const RESEND_INVITE_MAIL_SUCCESS = "RESEND_INVITE_MAIL_SUCCESS";
export const RESEND_INVITE_MAIL_FAIL = "RESEND_INVITE_MAIL_FAIL";

export const APPROVE_USER_BY_SUPER_ADMIN_REQUEST =
  "APPROVE_USER_BY_SUPER_ADMIN_REQUEST";
export const APPROVE_USER_BY_SUPER_ADMIN_SUCCESS =
  "APPROVE_USER_BY_SUPER_ADMIN_SUCCESS";
export const APPROVE_USER_BY_SUPER_ADMIN_FAIL =
  "APPROVE_USER_BY_SUPER_ADMIN_FAIL";

// user groups
export const GET_USER_GROUPS_LIST = "GET_USER_GROUPS_LIST";
export const GET_USER_GROUPS_SUCCESS = "GET_USER_GROUPS_SUCCESS";
export const GET_USER_GROUPS_FAIL = "GET_USER_GROUPS_FAIL";

// status
export const GET_STATUS_LIST = "GET_STATUS_LIST";
export const GET_STATUS_SUCCESS = "GET_STATUS_SUCCESS";
export const GET_STATUS_FAIL = "GET_STATUS_FAIL";

// truck
export const GET_TRUCK_LIST = "GET_TRUCK_LIST";
export const GET_TRUCK_LIST_SUCCESS = "GET_TRUCK_LIST_SUCCESS";
export const GET_TRUCK_LIST_FAIL = "GET_TRUCK_LIST_FAIL";

export const GET_SINGLE_TRUCK_REQUEST = "GET_SINGLE_TRUCK_REQUEST";
export const GET_SINGLE_TRUCK_SUCCESS = "GET_SINGLE_TRUCK_SUCCESS";
export const GET_SINGLE_TRUCK_FAIL = "GET_SINGLE_TRUCK_FAIL";

export const DELETE_TRUCK_REQUEST = "DELETE_TRUCK_REQUEST";
export const DELETE_TRUCK_SUCCESS = "DELETE_TRUCK_SUCCESS";
export const DELETE_TRUCK_FAIL = "DELETE_TRUCK_FAIL";

export const UPDATE_TRUCK_REQUEST = "UPDATE_TRUCK_REQUEST";
export const UPDATE_TRUCK_SUCCESS = "UPDATE_TRUCK_SUCCESS";
export const UPDATE_TRUCK_FAIL = "UPDATE_TRUCK_FAIL";

export const ADD_TRUCK_REQUEST = "ADD_TRUCK_REQUEST";
export const ADD_TRUCK_SUCCESS = "ADD_TRUCK_SUCCESS";
export const ADD_TRUCK_FAIL = "ADD_TRUCK_FAIL";

// trailer
export const GET_TRAILER_LIST = "GET_TRAILER_LIST";
export const GET_TRAILER_LIST_SUCCESS = "GET_TRAILER_LIST_SUCCESS";
export const GET_TRAILER_LIST_FAIL = "GET_TRAILER_LIST_FAIL";

export const GET_SINGLE_TRAILER_REQUEST = "GET_SINGLE_TRAILER_REQUEST";
export const GET_SINGLE_TRAILER_SUCCESS = "GET_SINGLE_TRAILER_SUCCESS";
export const GET_SINGLE_TRAILER_FAIL = "GET_SINGLE_TRAILER_FAIL";

export const DELETE_TRAILER_REQUEST = "DELETE_TRAILER_REQUEST";
export const DELETE_TRAILER_SUCCESS = "DELETE_TRAILER_SUCCESS";
export const DELETE_TRAILER_FAIL = "DELETE_TRAILER_FAIL";

export const UPDATE_TRAILER_REQUEST = "UPDATE_TRAILER_REQUEST";
export const UPDATE_TRAILER_SUCCESS = "UPDATE_TRAILER_SUCCESS";
export const UPDATE_TRAILER_FAIL = "UPDATE_TRAILER_FAIL";

export const ADD_TRAILER_REQUEST = "ADD_TRAILER_REQUEST";
export const ADD_TRAILER_SUCCESS = "ADD_TRAILER_SUCCESS";
export const ADD_TRAILER_FAIL = "ADD_TRAILER_FAIL";

// truck-owner
export const GET_TRUCK_OWNER_LIST = "GET_TRUCK_OWNER_LIST";
export const GET_TRUCK_OWNER_LIST_SUCCESS = "GET_TRUCK_OWNER_LIST_SUCCESS";
export const GET_TRUCK_OWNER_LIST_FAIL = "GET_TRUCK_OWNER_LIST_FAIL";

export const GET_SINGLE_TRUCK_OWNER_REQUEST = "GET_SINGLE_TRUCK_OWNER_REQUEST";
export const GET_SINGLE_TRUCK_OWNER_SUCCESS = "GET_SINGLE_TRUCK_OWNER_SUCCESS";
export const GET_SINGLE_TRUCK_OWNER_FAIL = "GET_SINGLE_TRUCK_OWNER_FAIL";

export const DELETE_TRUCK_OWNER_REQUEST = "DELETE_TRUCK_OWNER_REQUEST";
export const DELETE_TRUCK_OWNER_SUCCESS = "DELETE_TRUCK_OWNER_SUCCESS";
export const DELETE_TRUCK_OWNER_FAIL = "DELETE_TRUCK_OWNER_FAIL";

export const UPDATE_TRUCK_OWNER_REQUEST = "UPDATE_TRUCK_OWNER_REQUEST";
export const UPDATE_TRUCK_OWNER_SUCCESS = "UPDATE_TRUCK_OWNER_SUCCESS";
export const UPDATE_TRUCK_OWNER_FAIL = "UPDATE_TRUCK_OWNER_FAIL";

export const ADD_TRUCK_OWNER_REQUEST = "ADD_TRUCK_OWNER_REQUEST";
export const ADD_TRUCK_OWNER_SUCCESS = "ADD_TRUCK_OWNER_SUCCESS";
export const ADD_TRUCK_OWNER_FAIL = "ADD_TRUCK_OWNER_FAIL";

// sender
export const GET_SENDER_LIST = "GET_SENDER_LIST";
export const GET_SENDER_LIST_SUCCESS = "GET_SENDER_LIST_SUCCESS";
export const GET_SENDER_LIST_FAIL = "GET_SENDER_LIST_FAIL";

export const GET_SINGLE_SENDER = "GET_SINGLE_SENDER";
export const GET_SINGLE_SENDER_SUCCESS = "GET_SINGLE_SENDER_SUCCESS";
export const GET_SINGLE_SENDER_FAIL = "GET_SINGLE_SENDER_FAIL";

export const UPDATE_SENDER = "UPDATE_SENDER";
export const UPDATE_SENDER_SUCCESS = "UPDATE_SENDER_SUCCESS";
export const UPDATE_SENDER_FAIL = "UPDATE_SENDER_FAIL";

export const ADD_SENDER = "ADD_SENDER";
export const ADD_SENDER_SUCCESS = "ADD_SENDER_SUCCESS";
export const ADD_SENDER_FAIL = "ADD_SENDER_FAIL";

export const DELETE_SENDER = "DELETE_SENDER";
export const DELETE_SENDER_SUCCESS = "DELETE_SENDER_SUCCESS";
export const DELETE_SENDER_FAIL = "DELETE_SENDER_FAIL";

export const GET_SENDER_BRANCH_LIST_REQUEST = "GET_SENDER_BRANCH_LIST_REQUEST";
export const GET_SENDER_BRANCH_LIST_SUCCESS = "GET_SENDER_BRANCH_LIST_SUCCESS";
export const GET_SENDER_BRANCH_LIST_FAIL = "GET_SENDER_BRANCH_LIST_FAIL";

export const GET_SINGLE_SENDER_BRANCH_REQUEST =
  "GET_SINGLE_SENDER_BRANCH_REQUEST";
export const GET_SINGLE_SENDER_BRANCH_SUCCESS =
  "GET_SINGLE_SENDER_BRANCH_SUCCESS";
export const GET_SINGLE_SENDER_BRANCH_FAIL = "GET_SINGLE_SENDER_BRANCH_FAIL";

export const UPDATE_SENDER_BRANCH_REQUEST = "UPDATE_SENDER_BRANCH_REQUEST";
export const UPDATE_SENDER_BRANCH_SUCCESS = "UPDATE_SENDER_BRANCH_SUCCESS";
export const UPDATE_SENDER_BRANCH_FAIL = "UPDATE_SENDER_BRANCH_FAIL";

export const ADD_SENDER_BRANCH_REQUEST = "ADD_SENDER_BRANCH_REQUEST";
export const ADD_SENDER_BRANCH_SUCCESS = "ADD_SENDER_BRANCH_SUCCESS";
export const ADD_SENDER_BRANCH_FAIL = "ADD_SENDER_BRANCH_FAIL";

export const DELETE_SENDER_BRANCH_REQUEST = "DELETE_SENDER_BRANCH_REQUEST";
export const DELETE_SENDER_BRANCH_SUCCESS = "DELETE_SENDER_BRANCH_SUCCESS";
export const DELETE_SENDER_BRANCH_FAIL = "DELETE_SENDER_BRANCH_FAIL";

export const GET_SCALE_CAMERA_LIST_REQUEST = "GET_SCALE_CAMERA_LIST_REQUEST";
export const GET_SCALE_CAMERA_LIST_SUCCESS = "GET_SCALE_CAMERA_LIST_SUCCESS";
export const GET_SCALE_CAMERA_LIST_FAIL = "GET_SCALE_CAMERA_LIST_FAIL";

export const GET_SCALE_CAMERA_REQUEST = "GET_SCALE_CAMERA_REQUEST";
export const GET_SCALE_CAMERA_SUCCESS = "GET_SCALE_CAMERA_SUCCESS";
export const GET_SCALE_CAMERA_FAIL = "GET_SCALE_CAMERA_FAIL";

export const DELETE_SCALE_CAMERA_REQUEST = "DELETE_SCALE_CAMERA_REQUEST";
export const DELETE_SCALE_CAMERA_SUCCESS = "DELETE_SCALE_CAMERA_SUCCESS";
export const DELETE_SCALE_CAMERA_FAIL = "DELETE_SCALE_CAMERA_FAIL";

export const UPDATE_SCALE_CAMERA_REQUEST = "UPDATE_SCALE_CAMERA_REQUEST";
export const UPDATE_SCALE_CAMERA_SUCCESS = "UPDATE_SCALE_CAMERA_SUCCESS";
export const UPDATE_SCALE_CAMERA_FAIL = "UPDATE_SCALE_CAMERA_FAIL";

export const ADD_SCALE_CAMERA_REQUEST = "ADD_SCALE_CAMERA_REQUEST";
export const ADD_SCALE_CAMERA_SUCCESS = "ADD_SCALE_CAMERA_SUCCESS";
export const ADD_SCALE_CAMERA_FAIL = "ADD_SCALE_CAMERA_FAIL";

export const GET_SENDER_WAREHOUSE_CONFIG_LIST_REQUEST =
  "GET_SENDER_WAREHOUSE_CONFIG_LIST_REQUEST";
export const GET_SENDER_WAREHOUSE_CONFIG_LIST_SUCCESS =
  "GET_SENDER_WAREHOUSE_CONFIG_LIST_SUCCESS";
export const GET_SENDER_WAREHOUSE_CONFIG_LIST_FAIL =
  "GET_SENDER_WAREHOUSE_CONFIG_LIST_FAIL";

export const GET_SENDER_WAREHOUSE_CONFIG_REQUEST =
  "GET_SENDER_WAREHOUSE_CONFIG_REQUEST";
export const GET_SENDER_WAREHOUSE_CONFIG_SUCCESS =
  "GET_SENDER_WAREHOUSE_CONFIG_SUCCESS";
export const GET_SENDER_WAREHOUSE_CONFIG_FAIL =
  "GET_SENDER_WAREHOUSE_CONFIG_FAIL";

export const DELETE_SENDER_WAREHOUSE_CONFIG_REQUEST =
  "DELETE_SENDER_WAREHOUSE_CONFIG_REQUEST";
export const DELETE_SENDER_WAREHOUSE_CONFIG_SUCCESS =
  "DELETE_SENDER_WAREHOUSE_CONFIG_SUCCESS";
export const DELETE_SENDER_WAREHOUSE_CONFIG_FAIL =
  "DELETE_SENDER_WAREHOUSE_CONFIG_FAIL";

export const UPDATE_SENDER_WAREHOUSE_CONFIG_REQUEST =
  "UPDATE_SENDER_WAREHOUSE_CONFIG_REQUEST";
export const UPDATE_SENDER_WAREHOUSE_CONFIG_SUCCESS =
  "UPDATE_SENDER_WAREHOUSE_CONFIG_SUCCESS";
export const UPDATE_SENDER_WAREHOUSE_CONFIG_FAIL =
  "UPDATE_SENDER_WAREHOUSE_CONFIG_FAIL";

export const ADD_SENDER_WAREHOUSE_CONFIG_REQUEST =
  "ADD_SENDER_WAREHOUSE_CONFIG_REQUEST";
export const ADD_SENDER_WAREHOUSE_CONFIG_SUCCESS =
  "ADD_SENDER_WAREHOUSE_CONFIG_SUCCESS";
export const ADD_SENDER_WAREHOUSE_CONFIG_FAIL =
  "ADD_SENDER_WAREHOUSE_CONFIG_FAIL";

// company
export const GET_COMPANY_ALLOWED_IP_ADDRESS_LIST_REQUEST =
  "GET_COMPANY_ALLOWED_IP_ADDRESS_LIST_REQUEST";
export const GET_COMPANY_ALLOWED_IP_ADDRESS_LIST_SUCCESS =
  "GET_COMPANY_ALLOWED_IP_ADDRESS_LIST_SUCCESS";
export const GET_COMPANY_ALLOWED_IP_ADDRESS_LIST_FAIL =
  "GET_COMPANY_ALLOWED_IP_ADDRESS_LIST_FAIL";

export const GET_COMPANY_ALLOWED_IP_ADDRESS_REQUEST =
  "GET_COMPANY_ALLOWED_IP_ADDRESS_REQUEST";
export const GET_COMPANY_ALLOWED_IP_ADDRESS_SUCCESS =
  "GET_COMPANY_ALLOWED_IP_ADDRESS_SUCCESS";
export const GET_COMPANY_ALLOWED_IP_ADDRESS_FAIL =
  "GET_COMPANY_ALLOWED_IP_ADDRESS_FAIL";

export const DELETE_COMPANY_ALLOWED_IP_ADDRESS_REQUEST =
  "DELETE_COMPANY_ALLOWED_IP_ADDRESS_REQUEST";
export const DELETE_COMPANY_ALLOWED_IP_ADDRESS_SUCCESS =
  "DELETE_COMPANY_ALLOWED_IP_ADDRESS_SUCCESS";
export const DELETE_COMPANY_ALLOWED_IP_ADDRESS_FAIL =
  "DELETE_COMPANY_ALLOWED_IP_ADDRESS_FAIL";

export const UPDATE_COMPANY_ALLOWED_IP_ADDRESS_REQUEST =
  "UPDATE_COMPANY_ALLOWED_IP_ADDRESS_REQUEST";
export const UPDATE_COMPANY_ALLOWED_IP_ADDRESS_SUCCESS =
  "UPDATE_COMPANY_ALLOWED_IP_ADDRESS_SUCCESS";
export const UPDATE_COMPANY_ALLOWED_IP_ADDRESS_FAIL =
  "UPDATE_COMPANY_ALLOWED_IP_ADDRESS_FAIL";

export const ADD_COMPANY_ALLOWED_IP_ADDRESS_REQUEST =
  "ADD_COMPANY_ALLOWED_IP_ADDRESS_REQUEST";
export const ADD_COMPANY_ALLOWED_IP_ADDRESS_SUCCESS =
  "ADD_COMPANY_ALLOWED_IP_ADDRESS_SUCCESS";
export const ADD_COMPANY_ALLOWED_IP_ADDRESS_FAIL =
  "ADD_COMPANY_ALLOWED_IP_ADDRESS_FAIL";

export const REFRESH_MOBILE_AUTHORIZE_TOKEN_REQUEST =
  "REFRESH_MOBILE_AUTHORIZE_TOKEN_REQUEST";
export const REFRESH_MOBILE_AUTHORIZE_TOKEN_SUCCESS =
  "REFRESH_MOBILE_AUTHORIZE_TOKEN_SUCCESS";
export const REFRESH_MOBILE_AUTHORIZE_TOKEN_FAIL =
  "REFRESH_MOBILE_AUTHORIZE_TOKEN_FAIL";
/////////////////////////////////////////////////////////////////

export const GET_COMPANY_LIST = "GET_COMPANY_LIST";
export const GET_COMPANY_SUCCESS = "GET_COMPANY_SUCCESS";
export const GET_COMPANY_FAIL = "GET_COMPANY_FAIL";

export const GET_OPERATOR_COMPANY_LIST = "GET_OPERATOR_COMPANY_LIST";
export const GET_OPERATOR_COMPANY_SUCCESS = "GET_OPERATOR_COMPANY_SUCCESS";
export const GET_OPERATOR_COMPANY_FAIL = "GET_OPERATOR_COMPANY_FAIL";

export const GET_SINGLE_COMPANY_REQUEST = "GET_SINGLE_COMPANY_REQUEST";
export const GET_SINGLE_COMPANY_SUCCESS = "GET_SINGLE_COMPANY_SUCCESS";
export const GET_SINGLE_COMPANY_FAIL = "GET_SINGLE_COMPANY_FAIL";

export const DELETE_COMPANY_REQUEST = "DELETE_COMPANY_REQUEST";
export const DELETE_COMPANY_SUCCESS = "DELETE_COMPANY_SUCCESS";
export const DELETE_COMPANY_FAIL = "DELETE_COMPANY_FAIL";

export const UPDATE_COMPANY_REQUEST = "UPDATE_COMPANY_REQUEST";
export const UPDATE_COMPANY_SUCCESS = "UPDATE_COMPANY_SUCCESS";
export const UPDATE_COMPANY_FAIL = "UPDATE_COMPANY_FAIL";

export const ADD_COMPANY_REQUEST = "ADD_COMPANY_REQUEST";
export const ADD_COMPANY_SUCCESS = "ADD_COMPANY_SUCCESS";
export const ADD_COMPANY_FAIL = "ADD_COMPANY_FAIL";

export const CREATE_TELEGRAM_CHANNEL_REQUEST =
  "CREATE_TELEGRAM_CHANNEL_REQUEST";
export const CREATE_TELEGRAM_CHANNEL_SUCCESS =
  "CREATE_TELEGRAM_CHANNEL_SUCCESS";
export const CREATE_TELEGRAM_CHANNEL_FAIL = "CREATE_TELEGRAM_CHANNEL_FAIL";

export const ADD_OPERATOR_COMPANY_REQUEST = "ADD_OPERATOR_COMPANY_REQUEST";
export const ADD_OPERATOR_COMPANY_SUCCESS = "ADD_OPERATOR_COMPANY_SUCCESS";
export const ADD_OPERATOR_COMPANY_FAIL = "ADD_OPERATOR_COMPANY_FAIL";

export const ADD_PUBLIC_COMPANY_REQUEST = "ADD_PUBLIC_COMPANY_REQUEST";
export const ADD_PUBLIC_COMPANY_SUCCESS = "ADD_PUBLIC_COMPANY_SUCCESS";
export const ADD_PUBLIC_COMPANY_FAIL = "ADD_PUBLIC_COMPANY_FAIL";

export const EDIT_COMPANY_STATUS_REQUEST = "EDIT_COMPANY_STATUS_REQUEST";
export const EDIT_COMPANY_STATUS_SUCCESS = "EDIT_COMPANY_STATUS_SUCCESS";
export const EDIT_COMPANY_STATUS_FAIL = "EDIT_COMPANY_STATUS_FAIL";

export const GET_CALIBRATION_DATE = "GET_CALIBRATION_DATE";
export const RESET_CALIBRATION_DATE = "RESET_CALIBRATION_DATE";

// operations
export const UPLOAD_IMAGE_REQUEST = "UPLOAD_IMAGE_REQUEST";
export const UPLOAD_IMAGE_SUCCESS = "UPLOAD_IMAGE_SUCCESS";
export const UPLOAD_IMAGE_FAIL = "UPLOAD_IMAGE_FAIL";

export const SUBMIT_OPERATION_REQUEST = "SUBMIT_OPERATION_REQUEST";
export const SUBMIT_OPERATION_SUCCESS = "SUBMIT_OPERATION_SUCCESS";
export const SUBMIT_OPERATION_FAIL = "SUBMIT_OPERATION_FAIL";

export const GET_WEIGHT_REQUEST = "GET_WEIGHT_REQUEST";
export const GET_WEIGHT_SUCCESS = "GET_WEIGHT_SUCCESS";
export const GET_WEIGHT_FAIL = "GET_WEIGHT_FAIL";

export const RESET_WEIGHT = "RESET_WEIGHT";

export const GET_OPERATIONS_LIST_REQUEST = "GET_OPERATIONS_LIST_REQUEST";
export const GET_OPERATIONS_LIST_SUCCESS = "GET_OPERATIONS_LIST_SUCCESS";
export const GET_OPERATIONS_LIST_FAIL = "GET_OPERATIONS_LIST_FAIL";

export const GET_OPERATIONS_FOR_CUSTOMER_REQUEST =
  "GET_OPERATIONS_FOR_CUSTOMER_REQUEST";
export const GET_OPERATIONS_FOR_CUSTOMER_SUCCESS =
  "GET_OPERATIONS_FOR_CUSTOMER_SUCCESS";
export const GET_OPERATIONS_FOR_CUSTOMER_FAIL =
  "GET_OPERATIONS_FOR_CUSTOMER_FAIL";

export const GET_SINGLE_OPERATION_REQUEST = "GET_SINGLE_OPERATION_REQUEST";
export const GET_SINGLE_OPERATION_SUCCESS = "GET_SINGLE_OPERATION_SUCCESS";
export const GET_SINGLE_OPERATION_FAIL = "GET_SINGLE_OPERATION_FAIL";

export const RESET_SINGLE_OPERATION = "RESET_SINGLE_OPERATION";

export const UPDATE_OPERATION_REQUEST = "UPDATE_OPERATION_REQUEST";
export const UPDATE_OPERATION_SUCCESS = "UPDATE_OPERATION_SUCCESS";
export const UPDATE_OPERATION_FAIL = "UPDATE_OPERATION_FAIL";

export const GET_RECEIPT_REGUEST = "GET_RECEIPT_REGUEST";
export const GET_RECEIPT_SUCCESS = "GET_RECEIPT_SUCCESS";
export const GET_RECEIPT_FAIL = "GET_RECEIPT_FAIL";

export const DELETE_OPERATION_REQUEST = "DELETE_OPERATION_REQUEST";
export const DELETE_OPERATION_SUCCESS = "DELETE_OPERATION_SUCCESS";
export const DELETE_OPERATION_FAIL = "DELETE_OPERATION_FAIL";

export const OPERATION_CHANGE_APPROVE_REQUEST =
  "OPERATION_CHANGE_APPROVE_REQUEST";
export const OPERATION_CHANGE_APPROVE_SUCCESS =
  "OPERATION_CHANGE_APPROVE_SUCCESS";
export const OPERATION_CHANGE_APPROVE_FAIL = "OPERATION_CHANGE_APPROVE_FAIL";

export const OPERATION_CHANGE_CANCEL_REQUEST =
  "OPERATION_CHANGE_CANCEL_REQUEST";
export const OPERATION_CHANGE_CANCEL_SUCCESS =
  "OPERATION_CHANGE_CANCEL_SUCCESS";
export const OPERATION_CHANGE_CANCEL_FAIL = "OPERATION_CHANGE_CANCEL_FAIL";

export const OPERATION_DELETE_APPROVE_REQUEST =
  "OPERATION_DELETE_APPROVE_REQUEST";
export const OPERATION_DELETE_APPROVE_SUCCESS =
  "OPERATION_DELETE_APPROVE_SUCCESS";
export const OPERATION_DELETE_APPROVE_FAIL = "OPERATION_DELETE_APPROVE_FAIL";

export const OPERATION_DELETE_CANCEL_REQUEST =
  "OPERATION_DELETE_CANCEL_REQUEST";
export const OPERATION_DELETE_CANCEL_SUCCESS =
  "OPERATION_DELETE_CANCEL_SUCCESS";
export const OPERATION_DELETE_CANCEL_FAIL = "OPERATION_DELETE_CANCEL_FAIL";

export const ADD_LOSS_PERCENTAGE_REQUEST = "ADD_LOSS_PERCENTAGE_REQUEST";
export const ADD_LOSS_PERCENTAGE_SUCCESS = "ADD_LOSS_PERCENTAGE_SUCCESS";
export const ADD_LOSS_PERCENTAGE_FAIL = "ADD_LOSS_PERCENTAGE_FAIL";

// Operation file
export const GET_OPERATION_FILE = "GET_OPERATION_FILE";
export const GET_OPERATION_FILE_SUCCESS = "GET_OPERATION_FILE_SUCCESS";
export const GET_OPERATION_FILE_FAIL = "GET_OPERATION_FILE_FAIL";

// scale
export const GET_SCALE_LIST_REQUEST = "GET_SCALE_LIST_REQUEST";
export const GET_SCALE_LIST_SUCCESS = "GET_SCALE_LIST_SUCCESS";
export const GET_SCALE_LIST_FAIL = "GET_SCALE_LIST_FAIL";

export const GET_SINGLE_SCALE_REQUEST = "GET_SINGLE_SCALE_REQUEST";
export const GET_SINGLE_SCALE_SUCCESS = "GET_SINGLE_SCALE_SUCCESS";
export const GET_SINGLE_SCALE_FAIL = "GET_SINGLE_SCALE_FAIL";

export const UPDATE_SCALE_REQUEST = "UPDATE_SCALE_REQUEST";
export const UPDATE_SCALE_SUCCESS = "UPDATE_SCALE_SUCCESS";
export const UPDATE_SCALE_FAIL = "UPDATE_SCALE_FAIL";

export const UPDATE_SCALE2_REQUEST = "UPDATE_SCALE2_REQUEST";
export const UPDATE_SCALE2_SUCCESS = "UPDATE_SCALE2_SUCCESS";
export const UPDATE_SCALE2_FAIL = "UPDATE_SCALE2_FAIL";

export const ADD_SCALE_REQUEST = "ADD_SCALE_REQUEST";
export const ADD_SCALE_SUCCESS = "ADD_SCALE_SUCCESS";
export const ADD_SCALE_FAIL = "ADD_SCALE_FAIL";

export const DELETE_SCALE_REQUEST = "DELETE_SCALE_REQUEST";
export const DELETE_SCALE_SUCCESS = "DELETE_SCALE_SUCCESS";
export const DELETE_SCALE_FAIL = "DELETE_SCALE_FAIL";

// Print Types
export const GET_PRINT_TYPES_LIST = "GET_PRINT_TYPES_LIST";
export const GET_PRINT_TYPES_SUCCESS = "GET_PRINT_TYPES_SUCCESS";
export const GET_PRINT_TYPES_FAIL = "GET_PRINT_TYPES_FAIL";

// Reports
export const GET_SUMM_REPORT_REQUEST = "GET_SUMM_REPORT_REQUEST";
export const GET_SUMM_REPORT_SUCCESS = "GET_SUMM_REPORT_SUCCESS";
export const GET_SUMM_REPORT_FAIL = "GET_SUMM_REPORT_FAIL";

export const GET_DIVIDED_SUMM_REPORT_REQUEST =
  "GET_DIVIDED_SUMM_REPORT_REQUEST";
export const GET_DIVIDED_SUMM_REPORT_SUCCESS =
  "GET_DIVIDED_SUMM_REPORT_SUCCESS";
export const GET_DIVIDED_SUMM_REPORT_FAIL = "GET_DIVIDED_SUMM_REPORT_FAIL";

export const GET_SINGLE_REPORT_REQUEST = "GET_SINGLE_REPORT_REQUEST";
export const GET_SINGLE_REPORT_SUCCESS = "GET_SINGLE_REPORT_SUCCESS";
export const GET_SINGLE_REPORT_FAIL = "GET_SINGLE_REPORT_FAIL";

export const GET_GROUP_SUMM_REQUEST = "GET_GROUP_SUMM_REQUEST";
export const GET_GROUP_SUMM_SUCCESS = "GET_GROUP_SUMM_SUCCESS";
export const GET_GROUP_SUMM_FAIL = "GET_GROUP_SUMM_FAIL";

// Requests
export const GET_WAITING_REQUESTS = "GET_WAITING_REQUESTS";
export const GET_WAITING_REQUESTS_SUCCESS = "GET_WAITING_REQUESTS_SUCCESS";
export const GET_WAITING_REQUESTS_FAIL = "GET_WAITING_REQUESTS_FAIL";

export const GET_REQUEST_LOG = "GET_REQUEST_LOG";
export const GET_REQUEST_LOG_SUCCESS = "GET_REQUEST_LOG_SUCCESS";
export const GET_REQUEST_LOG_FAIL = "GET_REQUEST_LOG_FAIL";

export const GET_REQUEST_LOG_DETAIL = "GET_REQUEST_LOG_DETAIL";
export const GET_REQUEST_LOG_DETAIL_SUCCESS = "GET_REQUEST_LOG_DETAIL_SUCCESS";
export const GET_REQUEST_LOG_DETAIL_FAIL = "GET_REQUEST_LOG_DETAIL_FAIL";

export const RESET_NOTES = "RESET_NOTES";

export const GET_ACTION_LOGS_REQUEST = "GET_ACTION_LOGS_REQUEST";
export const GET_ACTION_LOGS_SUCCESS = "GET_ACTION_LOGS_SUCCESS";
export const GET_ACTION_LOGS_FAIL = "GET_ACTION_LOGS_FAIL";

export const GET_INCOME_OPERATION_LIST_REQUEST =
  "GET_INCOME_OPERATION_LIST_REQUEST";
export const GET_INCOME_OPERATION_LIST_SUCCESS =
  "GET_INCOME_OPERATION_LIST_SUCCESS";
export const GET_INCOME_OPERATION_LIST_FAIL = "GET_INCOME_OPERATION_LIST_FAIL";

export const GET_SINGLE_INCOME_OPERATION_REQUEST =
  "GET_SINGLE_INCOME_OPERATION_REQUEST";
export const GET_SINGLE_INCOME_OPERATION_SUCCESS =
  "GET_SINGLE_INCOME_OPERATION_SUCCESS";
export const GET_SINGLE_INCOME_OPERATION_FAIL =
  "GET_SINGLE_INCOME_OPERATION_FAIL";

export const GET_ACTION_LOG_DETAIL_REQUEST = "GET_ACTION_LOG_DETAIL_REQUEST";
export const GET_ACTION_LOG_DETAIL_SUCCESS = "GET_ACTION_LOG_DETAIL_SUCCESS";
export const GET_ACTION_LOG_DETAIL_FAIL = "GET_ACTION_LOG_DETAIL_FAIL";

export const GET_LPI_DEVICE_LOG_REQUEST = "GET_LPI_DEVICE_LOG_REQUEST";
export const GET_LPI_DEVICE_LOG_SUCCESS = "GET_LPI_DEVICE_LOG_SUCCESS";
export const GET_LPI_DEVICE_LOG_FAIL = "GET_LPI_DEVICE_LOG_FAIL";

export const GET_LPI_CALIBRATION_LOG_REQUEST =
  "GET_LPI_CALIBRATION_LOG_REQUEST";
export const GET_LPI_CALIBRATION_LOG_SUCCESS =
  "GET_LPI_CALIBRATION_LOG_SUCCESS";
export const GET_LPI_CALIBRATION_LOG_FAIL = "GET_LPI_CALIBRATION_LOG_FAIL";

export const GET_SINGLE_LPI_DEVICE_LOG_REQUEST =
  "GET_SINGLE_LPI_DEVICE_LOG_REQUEST";
export const GET_SINGLE_LPI_DEVICE_LOG_SUCCESS =
  "GET_SINGLE_LPI_DEVICE_LOG_SUCCESS";
export const GET_SINGLE_LPI_DEVICE_LOG_FAIL = "GET_SINGLE_LPI_DEVICE_LOG_FAIL";

export const GET_SINGLE_LPI_CALIBRATION_LOG_REQUEST =
  "GET_SINGLE_LPI_CALIBRATION_LOG_REQUEST";
export const GET_SINGLE_LPI_CALIBRATION_LOG_SUCCESS =
  "GET_SINGLE_LPI_CALIBRATION_LOG_SUCCESS";
export const GET_SINGLE_LPI_CALIBRATION_LOG_FAIL =
  "GET_SINGLE_LPI_CALIBRATION_LOG_FAIL";

export const CALIBRATION_SHOW_REQUEST = "CALIBRATION_SHOW_REQUEST";
export const CALIBRATION_SHOW_SUCCESS = "CALIBRATION_SHOW_SUCCESS";
export const CALIBRATION_SHOW_FAIL = "CALIBRATION_SHOW_FAIL";

export const GET_KEYPAD_LOCK_STATUS_REQUEST = "GET_KEYPAD_LOCK_STATUS_REQUEST";
export const GET_KEYPAD_LOCK_STATUS_SUCCESS = "GET_KEYPAD_LOCK_STATUS_SUCCESS";
export const GET_KEYPAD_LOCK_STATUS_FAIL = "GET_KEYPAD_LOCK_STATUS_FAIL";

export const KEYPAD_LOCK_REQUEST = "KEYPAD_LOCK_REQUEST";
export const KEYPAD_LOCK_SUCCESS = "KEYPAD_LOCK_SUCCESS";
export const KEYPAD_LOCK_FAIL = "KEYPAD_LOCK_FAIL";

export const LPI_RESET_REQUEST = "LPI_RESET_REQUEST";
export const LPI_RESET_SUCCESS = "LPI_RESET_SUCCESS";
export const LPI_RESET_FAIL = "LPI_RESET_FAIL";

export const KEYPAD_UNLOCK_REQUEST = "KEYPAD_UNLOCK_REQUEST";
export const KEYPAD_UNLOCK_SUCCESS = "KEYPAD_UNLOCK_SUCCESS";
export const KEYPAD_UNLOCK_FAIL = "KEYPAD_UNLOCK_FAIL";

export const GET_READ_WEIGHT_REQUEST = "GET_READ_WEIGHT_REQUEST";
export const GET_READ_WEIGHT_SUCCESS = "GET_READ_WEIGHT_SUCCESS";
export const GET_READ_WEIGHT_FAIL = "GET_READ_WEIGHT_FAIL";

export const CALIBRATE_REQUEST = "CALIBRATE_REQUEST";
export const CALIBRATE_SUCCESS = "CALIBRATE_SUCCESS";
export const CALIBRATE_FAIL = "CALIBRATE_FAIL";

export const CALIBRATE1_REQUEST = "CALIBRATE1_REQUEST";
export const CALIBRATE1_SUCCESS = "CALIBRATE1_SUCCESS";
export const CALIBRATE1_FAIL = "CALIBRATE1_FAIL";

export const CALIBRATE3_REQUEST = "CALIBRATE3_REQUEST";
export const CALIBRATE3_SUCCESS = "CALIBRATE3_SUCCESS";
export const CALIBRATE3_FAIL = "CALIBRATE3_FAIL";

export const RESET_READ_WEIGHT = "RESET_READ_WEIGHT";

export const GET_OP_READ_WEIGHT_REQUEST = "GET_OP_READ_WEIGHT_REQUEST";
export const GET_OP_READ_WEIGHT_SUCCESS = "GET_OP_READ_WEIGHT_SUCCESS";
export const GET_OP_READ_WEIGHT_FAIL = "GET_OP_READ_WEIGHT_FAIL";

export const GET_OP_TRB_WEIGHT_REQUEST = "GET_OP_TRB_WEIGHT_REQUEST";
export const GET_OP_TRB_WEIGHT_SUCCESS = "GET_OP_TRB_WEIGHT_SUCCESS";
export const GET_OP_TRB_WEIGHT_FAIL = "GET_OP_TRB_WEIGHT_FAIL";

// CardType
export const GET_CARD_TYPES_REQUEST = "GET_CARD_TYPES_REQUEST";
export const GET_CARD_TYPES_SUCCESS = "GET_CARD_TYPES_SUCCESS";
export const GET_CARD_TYPES_FAIL = "GET_CARD_TYPES_FAIL";

// RfidCard
export const GET_RFID_CARD_LIST_REQUEST = "GET_RFID_CARD_LIST_REQUEST";
export const GET_RFID_CARD_LIST_SUCCESS = "GET_RFID_CARD_LIST_SUCCESS";
export const GET_RFID_CARD_LIST_FAIL = "GET_RFID_CARD_LIST_FAIL";

export const GET_SINGLE_RFID_CARD_REQUEST = "GET_SINGLE_RFID_CARD_REQUEST";
export const GET_SINGLE_RFID_CARD_SUCCESS = "GET_SINGLE_RFID_CARD_SUCCESS";
export const GET_SINGLE_RFID_CARD_FAIL = "GET_SINGLE_RFID_CARD_FAIL";

export const ADD_RFID_CARD_REQUEST = "ADD_RFID_CARD_REQUEST";
export const ADD_RFID_CARD_SUCCESS = "ADD_RFID_CARD_SUCCESS";
export const ADD_RFID_CARD_FAIL = "ADD_RFID_CARD_FAIL";

export const UPDATE_RFID_CARD_REQUEST = "UPDATE_RFID_CARD_REQUEST";
export const UPDATE_RFID_CARD_SUCCESS = "UPDATE_RFID_CARD_SUCCESS";
export const UPDATE_RFID_CARD_FAIL = "UPDATE_RFID_CARD_FAIL";

export const DELETE_RFID_CARD_REQUEST = "DELETE_RFID_CARD_REQUEST";
export const DELETE_RFID_CARD_SUCCESS = "DELETE_RFID_CARD_SUCCESS";
export const DELETE_RFID_CARD_FAIL = "DELETE_RFID_CARD_FAIL";

export const APPROVE_DELETE_RFID_CARD_REQUEST =
  "APPROVE_DELETE_RFID_CARD_REQUEST";
export const APPROVE_DELETE_RFID_CARD_SUCCESS =
  "APPROVE_DELETE_RFID_CARD_SUCCESS";
export const APPROVE_DELETE_RFID_CARD_FAIL = "APPROVE_DELETE_RFID_CARD_FAIL";

export const CANCEL_DELETE_RFID_CARD_REQUEST =
  "CANCEL_DELETE_RFID_CARD_REQUEST";
export const CANCEL_DELETE_RFID_CARD_SUCCESS =
  "CANCEL_DELETE_RFID_CARD_SUCCESS";
export const CANCEL_DELETE_RFID_CARD_FAIL = "CANCEL_DELETE_RFID_CARD_FAIL";

export const RESET_RFID_CARD_REQUEST = "RESET_RFID_CARD_REQUEST";
export const RESET_RFID_CARD_SUCCESS = "RESET_RFID_CARD_SUCCESS";
export const RESET_RFID_CARD_FAIL = "RESET_RFID_CARD_FAIL";

export const APPROVE_RESET_RFID_CARD_REQUEST =
  "APPROVE_RESET_RFID_CARD_REQUEST";
export const APPROVE_RESET_RFID_CARD_SUCCESS =
  "APPROVE_RESET_RFID_CARD_SUCCESS";
export const APPROVE_RESET_RFID_CARD_FAIL = "APPROVE_RESET_RFID_CARD_FAIL";

export const CANCEL_RESET_RFID_CARD_REQUEST = "CANCEL_RESET_RFID_CARD_REQUEST";
export const CANCEL_RESET_RFID_CARD_SUCCESS = "CANCEL_RESET_RFID_CARD_SUCCESS";
export const CANCEL_RESET_RFID_CARD_FAIL = "CANCEL_RESET_RFID_CARD_FAIL";

export const GET_RFID_CARD_HISTORY_REQUEST = "GET_RFID_CARD_HISTORY_REQUEST";
export const GET_RFID_CARD_HISTORY_SUCCESS = "GET_RFID_CARD_HISTORY_SUCCESS";
export const GET_RFID_CARD_HISTORY_FAIL = "GET_RFID_CARD_HISTORY_FAIL";

export const GET_RFID_NUMBER_FROM_DEVICE_REQUEST =
  "GET_RFID_NUMBER_FROM_DEVICE_REQUEST";
export const GET_RFID_NUMBER_FROM_DEVICE_SUCCESS =
  "GET_RFID_NUMBER_FROM_DEVICE_SUCCESS";
export const GET_RFID_NUMBER_FROM_DEVICE_FAIL =
  "GET_RFID_NUMBER_FROM_DEVICE_FAIL";

export const GET_RFID_CARD_FROM_NUMBER_REQUEST =
  "GET_RFID_CARD_FROM_NUMBER_REQUEST";
export const GET_RFID_CARD_FROM_NUMBER_SUCCESS =
  "GET_RFID_CARD_FROM_NUMBER_SUCCESS";
export const GET_RFID_CARD_FROM_NUMBER_FAIL = "GET_RFID_CARD_FROM_NUMBER_FAIL";

// RfidCard Operation
export const GET_RFID_CARD_OPERATION_LIST_REQUEST =
  "GET_RFID_CARD_OPERATION_LIST_REQUEST";
export const GET_RFID_CARD_OPERATION_LIST_SUCCESS =
  "GET_RFID_CARD_OPERATION_LIST_SUCCESS";
export const GET_RFID_CARD_OPERATION_LIST_FAIL =
  "GET_RFID_CARD_OPERATION_LIST_FAIL";

export const GET_SINGLE_RFID_CARD_OPERATION_REQUEST =
  "GET_SINGLE_RFID_CARD_OPERATION_REQUEST";
export const GET_SINGLE_RFID_CARD_OPERATION_SUCCESS =
  "GET_SINGLE_RFID_CARD_OPERATION_SUCCESS";
export const GET_SINGLE_RFID_CARD_OPERATION_FAIL =
  "GET_SINGLE_RFID_CARD_OPERATION_FAIL";

export const ADD_RFID_CARD_OPERATION_REQUEST =
  "ADD_RFID_CARD_OPERATION_REQUEST";
export const ADD_RFID_CARD_OPERATION_SUCCESS =
  "ADD_RFID_CARD_OPERATION_SUCCESS";
export const ADD_RFID_CARD_OPERATION_FAIL = "ADD_RFID_CARD_OPERATION_FAIL";

export const UPDATE_RFID_CARD_OPERATION_REQUEST =
  "UPDATE_RFID_CARD_OPERATION_REQUEST";
export const UPDATE_RFID_CARD_OPERATION_SUCCESS =
  "UPDATE_RFID_CARD_OPERATION_SUCCESS";
export const UPDATE_RFID_CARD_OPERATION_FAIL =
  "UPDATE_RFID_CARD_OPERATION_FAIL";

export const RESET_RFID_NUMBER_REQUEST = "RESET_RFID_NUMBER_REQUEST";
export const RESET_RFID_NUMBER_SUCCESS = "RESET_RFID_NUMBER_SUCCESS";
export const RESET_RFID_NUMBER_FAIL = "RESET_RFID_NUMBER_FAIL";

export const RESET_SINGLE_RFID_CARD_REQUEST = "RESET_SINGLE_RFID_CARD_REQUEST";
export const RESET_SINGLE_RFID_CARD_SUCCESS = "RESET_SINGLE_RFID_CARD_SUCCESS";
export const RESET_SINGLE_RFID_CARD_FAIL = "RESET_SINGLE_RFID_CARD_FAIL";

export const SUBMIT_AUTO_SCALE_REQUEST = "SUBMIT_AUTO_SCALE_REQUEST";
export const SUBMIT_AUTO_SCALE_SUCCESS = "SUBMIT_AUTO_SCALE_SUCCESS";
export const SUBMIT_AUTO_SCALE_FAIL = "SUBMIT_AUTO_SCALE_FAIL";

export const UPDATE_AUTO_SCALE_REQUEST = "UPDATE_AUTO_SCALE_REQUEST";
export const UPDATE_AUTO_SCALE_SUCCESS = "UPDATE_AUTO_SCALE_SUCCESS";
export const UPDATE_AUTO_SCALE_FAIL = "UPDATE_AUTO_SCALE_FAIL";

export const OPEN_TRB_REQUEST = "OPEN_TRB_REQUEST";
export const OPEN_TRB_SUCCESS = "OPEN_TRB_SUCCESS";
export const GET_LIGHT_STATE_SUCCESS = "GET_LIGHT_STATE_SUCCESS";
export const OPEN_TRB_FAIL = "OPEN_TRB_FAIL";

export const OPEN_ZKTECO_REQUEST = "OPEN_ZKTECO_REQUEST";
export const OPEN_ZKTECO_SUCCESS = "OPEN_ZKTECO_SUCCESS";
export const OPEN_ZKTECO_FAIL = "OPEN_ZKTECO_FAIL";

export const LISTEN_ZKTECO_REQUEST = "LISTEN_ZKTECO_REQUEST";
export const LISTEN_ZKTECO_SUCCESS = "LISTEN_ZKTECO_SUCCESS";
export const LISTEN_ZKTECO_FAIL = "LISTEN_ZKTECO_FAIL";

// OrderPart
export const GET_ORDER_PART_LIST_REQUEST = "GET_ORDER_PART_LIST_REQUEST";
export const GET_ORDER_PART_LIST_SUCCESS = "GET_ORDER_PART_LIST_SUCCESS";
export const GET_ORDER_PART_LIST_FAIL = "GET_ORDER_PART_LIST_FAIL";

export const GET_SINGLE_ORDER_PART_REQUEST = "GET_SINGLE_ORDER_PART_REQUEST";
export const GET_SINGLE_ORDER_PART_SUCCESS = "GET_SINGLE_ORDER_PART_SUCCESS";
export const GET_SINGLE_ORDER_PART_FAIL = "GET_SINGLE_ORDER_PART_FAIL";

export const UPDATE_ORDER_PART_REQUEST = "UPDATE_ORDER_PART_REQUEST";
export const UPDATE_ORDER_PART_SUCCESS = "UPDATE_ORDER_PART_SUCCESS";
export const UPDATE_ORDER_PART_FAIL = "UPDATE_ORDER_PART_FAIL";

export const LOGON_EDIT_TRUCK_REQUEST = "LOGON_EDIT_TRUCK_REQUEST";
export const LOGON_EDIT_TRUCK_SUCCESS = "LOGON_EDIT_TRUCK_SUCCESS";
export const LOGON_EDIT_TRUCK_FAIL = "LOGON_EDIT_TRUCK_FAIL";

export const DELETE_ORDER_PART_REQUEST = "DELETE_ORDER_PART_REQUEST";
export const DELETE_ORDER_PART_SUCCESS = "DELETE_ORDER_PART_SUCCESS";
export const DELETE_ORDER_PART_FAIL = "DELETE_ORDER_PART_FAIL";

export const ADD_ORDER_PART_REQUEST = "ADD_ORDER_PART_REQUEST";
export const ADD_ORDER_PART_SUCCESS = "ADD_ORDER_PART_SUCCESS";
export const ADD_ORDER_PART_FAIL = "ADD_ORDER_PART_FAIL";

export const GET_ORDER_PART_LOG_REQUEST = "GET_ORDER_PART_LOG_REQUEST";
export const GET_ORDER_PART_LOG_SUCCESS = "GET_ORDER_PART_LOG_SUCCESS";
export const GET_ORDER_PART_LOG_FAIL = "GET_ORDER_PART_LOG_FAIL";

export const GET_TRUCK_EMPTY_WEIGHT_LOG_REQUEST = "GET_TRUCK_EMPTY_WEIGHT_LOG_REQUEST";
export const GET_TRUCK_EMPTY_WEIGHT_LOG_SUCCESS = "GET_TRUCK_EMPTY_WEIGHT_LOG_SUCCESS";
export const GET_TRUCK_EMPTY_WEIGHT_LOG_FAIL = "GET_TRUCK_EMPTY_WEIGHT_LOG_FAIL";

export const GET_ORDER_PART_STEP_LIST_REQUEST =
  "GET_ORDER_PART_STEP_LIST_REQUEST";
export const GET_ORDER_PART_STEP_LIST_SUCCESS =
  "GET_ORDER_PART_STEP_LIST_SUCCESS";
export const GET_ORDER_PART_STEP_LIST_FAIL = "GET_ORDER_PART_STEP_LIST_FAIL";

export const GET_ORDER_PART_MANUAL_STEP_LIST_REQUEST =
  "GET_ORDER_PART_MANUAL_STEP_LIST_REQUEST";
export const GET_ORDER_PART_MANUAL_STEP_LIST_SUCCESS =
  "GET_ORDER_PART_MANUAL_STEP_LIST_SUCCESS";
export const GET_ORDER_PART_MANUAL_STEP_LIST_FAIL =
  "GET_ORDER_PART_MANUAL_STEP_LIST_FAIL";

export const EDIT_ORDER_PART_STEP_REQUEST = "EDIT_ORDER_PART_STEP_REQUEST";
export const EDIT_ORDER_PART_STEP_SUCCESS = "EDIT_ORDER_PART_STEP_SUCCESS";
export const EDIT_ORDER_PART_STEP_FAIL = "EDIT_ORDER_PART_STEP_FAIL";

export const EDIT_ORDER_PART_MANUAL_STEP_REQUEST =
  "EDIT_ORDER_PART_MANUAL_STEP_REQUEST";
export const EDIT_ORDER_PART_MANUAL_STEP_SUCCESS =
  "EDIT_ORDER_PART_MANUAL_STEP_SUCCESS";
export const EDIT_ORDER_PART_MANUAL_STEP_FAIL =
  "EDIT_ORDER_PART_MANUAL_STEP_FAIL";

// Order
export const GET_ORDER_ORDER_PART_LIST_REQUEST =
  "GET_ORDER_ORDER_PART_LIST_REQUEST";
export const GET_ORDER_ORDER_PART_LIST_SUCCESS =
  "GET_ORDER_ORDER_PART_LIST_SUCCESS";
export const GET_ORDER_ORDER_PART_LIST_FAIL = "GET_ORDER_ORDER_PART_LIST_FAIL";

export const GET_STEP1_ORDER_PARTS_REQUEST = "GET_STEP1_ORDER_PARTS_REQUEST";
export const GET_STEP1_ORDER_PARTS_SUCCESS = "GET_STEP1_ORDER_PARTS_SUCCESS";
export const GET_STEP1_ORDER_PARTS_FAIL = "GET_STEP1_ORDER_PARTS_FAIL";

export const GET_STEP2_ORDER_PARTS_REQUEST = "GET_STEP2_ORDER_PARTS_REQUEST";
export const GET_STEP2_ORDER_PARTS_SUCCESS = "GET_STEP2_ORDER_PARTS_SUCCESS";
export const GET_STEP2_ORDER_PARTS_FAIL = "GET_STEP2_ORDER_PARTS_FAIL";

export const GET_ACTIVE_ORDER_PARTS_REQUEST = "GET_ACTIVE_ORDER_PARTS_REQUEST";
export const GET_ACTIVE_ORDER_PARTS_SUCCESS = "GET_ACTIVE_ORDER_PARTS_SUCCESS";
export const GET_ACTIVE_ORDER_PARTS_FAIL = "GET_ACTIVE_ORDER_PARTS_FAIL";

export const GET_ORDER_LIST_REQUEST = "GET_ORDER_LIST_REQUEST";
export const GET_ORDER_LIST_SUCCESS = "GET_ORDER_LIST_SUCCESS";
export const GET_ORDER_LIST_FAIL = "GET_ORDER_LIST_FAIL";

export const GET_LOGON_REQUESTS = "GET_LOGON_REQUESTS";
export const GET_LOGON_REQUESTS_SUCCESS = "GET_LOGON_REQUESTS_SUCCESS";
export const GET_LOGON_REQUESTS_FAIL = "GET_LOGON_REQUESTS_FAIL";
export const GET_ORDER_TYPE = "GET_ORDER_TYPE";
export const GET_ORDER_TYPE_SUCCESS = "GET_ORDER_TYPE_SUCCESS";
export const GET_ORDER_TYPE_FAIL = "GET_ORDER_TYPE_FAIL";

export const GET_LOGON_DETAILS_REQUEST = "GET_LOGON_DETAILS_REQUEST";
export const GET_LOGON_DETAILS_SUCCESS = "GET_LOGON_DETAILS_SUCCESS";
export const GET_LOGON_DETAILS_FAIL = "GET_LOGON_DETAILS_FAIL";

export const GET_SINGLE_ORDER_REQUEST = "GET_SINGLE_ORDER_REQUEST";
export const GET_SINGLE_ORDER_SUCCESS = "GET_SINGLE_ORDER_SUCCESS";
export const GET_SINGLE_ORDER_FAIL = "GET_SINGLE_ORDER_FAIL";

export const ADD_ORDER_REQUEST = "ADD_ORDER_REQUEST";
export const ADD_ORDER_SUCCESS = "ADD_ORDER_SUCCESS";
export const ADD_ORDER_FAIL = "ADD_ORDER_FAIL";

export const LOGON_REPROCESS_REQUEST = "LOGON_REPROCESS_REQUEST";
export const LOGON_REPROCESS_SUCCESS = "LOGON_REPROCESS_SUCCESS";
export const LOGON_REPROCESS_FAIL = "LOGON_REPROCESS_FAIL";

export const UPDATE_ORDER_REQUEST = "UPDATE_ORDER_REQUEST";
export const UPDATE_ORDER_SUCCESS = "UPDATE_ORDER_SUCCESS";
export const UPDATE_ORDER_FAIL = "UPDATE_ORDER_FAIL";

export const DELETE_ORDER_REQUEST = "DELETE_ORDER_REQUEST";
export const DELETE_ORDER_SUCCESS = "DELETE_ORDER_SUCCESS";
export const DELETE_ORDER_FAIL = "DELETE_ORDER_FAIL";

export const CREATE_ORDER_REQUEST = "CREATE_ORDER_REQUEST";
export const CREATE_ORDER_SUCCESS = "CREATE_ORDER_SUCCESS";
export const CREATE_ORDER_FAIL = "CREATE_ORDER_FAIL";

// Area
export const GET_COUNTRY_LIST_REQUEST = "GET_COUNTRY_LIST_REQUEST";
export const GET_COUNTRY_LIST_SUCCESS = "GET_COUNTRY_LIST_SUCCESS";
export const GET_COUNTRY_LIST_FAIL = "GET_COUNTRY_LIST_FAIL";

export const GET_AREA_LIST_REQUEST = "GET_AREA_LIST_REQUEST";
export const GET_AREA_LIST_SUCCESS = "GET_AREA_LIST_SUCCESS";
export const GET_AREA_LIST_FAIL = "GET_AREA_LIST_FAIL";

// District
export const GET_DISTRICT_LIST_REQUEST = "GET_DISTRICT_LIST_REQUEST";
export const GET_DISTRICT_LIST_SUCCESS = "GET_DISTRICT_LIST_SUCCESS";
export const GET_DISTRICT_LIST_FAIL = "GET_DISTRICT_LIST_FAIL";

export const GET_TRAILER_CAR_BRAND_LIST_REQUEST =
  "GET_TRAILER_CAR_BRAND_LIST_REQUEST";
export const GET_TRAILER_CAR_BRAND_LIST_SUCCESS =
  "GET_TRAILER_CAR_BRAND_LIST_SUCCESS";
export const GET_TRAILER_CAR_BRAND_LIST_FAIL =
  "GET_TRAILER_CAR_BRAND_LIST_FAIL";

export const GET_TRAILER_CAR_MODEL_LIST_REQUEST =
  "GET_TRAILER_CAR_MODEL_LIST_REQUEST";
export const GET_TRAILER_CAR_MODEL_LIST_SUCCESS =
  "GET_TRAILER_CAR_MODEL_LIST_SUCCESS";
export const GET_TRAILER_CAR_MODEL_LIST_FAIL =
  "GET_TRAILER_CAR_MODEL_LIST_FAIL";

export const GET_CAR_BRAND_LIST_REQUEST = "GET_CAR_BRAND_LIST_REQUEST";
export const GET_CAR_BRAND_LIST_SUCCESS = "GET_CAR_BRAND_LIST_SUCCESS";
export const GET_CAR_BRAND_LIST_FAIL = "GET_CAR_BRAND_LIST_FAIL";

export const GET_SINGLE_CAR_BRAND_REQUEST = "GET_SINGLE_CAR_BRAND_REQUEST";
export const GET_SINGLE_CAR_BRAND_SUCCESS = "GET_SINGLE_CAR_BRAND_SUCCESS";
export const GET_SINGLE_CAR_BRAND_FAIL = "GET_SINGLE_CAR_BRAND_FAIL";

export const ADD_CAR_BRAND_REQUEST = "ADD_CAR_BRAND_REQUEST";
export const ADD_CAR_BRAND_SUCCESS = "ADD_CAR_BRAND_SUCCESS";
export const ADD_CAR_BRAND_FAIL = "ADD_CAR_BRAND_FAIL";

export const UPDATE_CAR_BRAND_REQUEST = "UPDATE_CAR_BRAND_REQUEST";
export const UPDATE_CAR_BRAND_SUCCESS = "UPDATE_CAR_BRAND_SUCCESS";
export const UPDATE_CAR_BRAND_FAIL = "UPDATE_CAR_BRAND_FAIL";

export const DELETE_CAR_BRAND_REQUEST = "DELETE_CAR_BRAND_REQUEST";
export const DELETE_CAR_BRAND_SUCCESS = "DELETE_CAR_BRAND_SUCCESS";
export const DELETE_CAR_BRAND_FAIL = "DELETE_CAR_BRAND_FAIL";

export const GET_CAR_MODEL_LIST_REQUEST = "GET_CAR_MODEL_LIST_REQUEST";
export const GET_CAR_MODEL_LIST_SUCCESS = "GET_CAR_MODEL_LIST_SUCCESS";
export const GET_CAR_MODEL_LIST_FAIL = "GET_CAR_MODEL_LIST_FAIL";

export const GET_SINGLE_CAR_MODEL_REQUEST = "GET_SINGLE_CAR_MODEL_REQUEST";
export const GET_SINGLE_CAR_MODEL_SUCCESS = "GET_SINGLE_CAR_MODEL_SUCCESS";
export const GET_SINGLE_CAR_MODEL_FAIL = "GET_SINGLE_CAR_MODEL_FAIL";

export const ADD_CAR_MODEL_REQUEST = "ADD_CAR_MODEL_REQUEST";
export const ADD_CAR_MODEL_SUCCESS = "ADD_CAR_MODEL_SUCCESS";
export const ADD_CAR_MODEL_FAIL = "ADD_CAR_MODEL_FAIL";

export const UPDATE_CAR_MODEL_REQUEST = "UPDATE_CAR_MODEL_REQUEST";
export const UPDATE_CAR_MODEL_SUCCESS = "UPDATE_CAR_MODEL_SUCCESS";
export const UPDATE_CAR_MODEL_FAIL = "UPDATE_CAR_MODEL_FAIL";

export const DELETE_CAR_MODEL_REQUEST = "DELETE_CAR_MODEL_REQUEST";
export const DELETE_CAR_MODEL_SUCCESS = "DELETE_CAR_MODEL_SUCCESS";
export const DELETE_CAR_MODEL_FAIL = "DELETE_CAR_MODEL_FAIL";

export const GET_TRUCK_TYPE_LIST_REQUEST = "GET_TRUCK_TYPE_LIST_REQUEST";
export const GET_TRUCK_TYPE_LIST_SUCCESS = "GET_TRUCK_TYPE_LIST_SUCCESS";
export const GET_TRUCK_TYPE_LIST_FAIL = "GET_TRUCK_TYPE_LIST_FAIL";

export const GET_SINGLE_TRUCK_TYPE_REQUEST = "GET_SINGLE_TRUCK_TYPE_REQUEST";
export const GET_SINGLE_TRUCK_TYPE_SUCCESS = "GET_SINGLE_TRUCK_TYPE_SUCCESS";
export const GET_SINGLE_TRUCK_TYPE_FAIL = "GET_SINGLE_TRUCK_TYPE_FAIL";

export const ADD_TRUCK_TYPE_REQUEST = "ADD_TRUCK_TYPE_REQUEST";
export const ADD_TRUCK_TYPE_SUCCESS = "ADD_TRUCK_TYPE_SUCCESS";
export const ADD_TRUCK_TYPE_FAIL = "ADD_TRUCK_TYPE_FAIL";

export const UPDATE_TRUCK_TYPE_REQUEST = "UPDATE_TRUCK_TYPE_REQUEST";
export const UPDATE_TRUCK_TYPE_SUCCESS = "UPDATE_TRUCK_TYPE_SUCCESS";
export const UPDATE_TRUCK_TYPE_FAIL = "UPDATE_TRUCK_TYPE_FAIL";

export const DELETE_TRUCK_TYPE_REQUEST = "DELETE_TRUCK_TYPE_REQUEST";
export const DELETE_TRUCK_TYPE_SUCCESS = "DELETE_TRUCK_TYPE_SUCCESS";
export const DELETE_TRUCK_TYPE_FAIL = "DELETE_TRUCK_TYPE_FAIL";

export const COMPLETE_OPERATION_WITHOUT_WEIGHT2_REQUEST =
  "COMPLETE_OPERATION_WITHOUT_WEIGHT2_REQUEST";
export const COMPLETE_OPERATION_WITHOUT_WEIGHT2_SUCCESS =
  "COMPLETE_OPERATION_WITHOUT_WEIGHT2_SUCCESS";
export const COMPLETE_OPERATION_WITHOUT_WEIGHT2_FAIL =
  "COMPLETE_OPERATION_WITHOUT_WEIGHT2_FAIL";

export const COMPLETE_OPERATION_WITH_TECH_PASS_WEIGHT_REQUEST =
  "COMPLETE_OPERATION_WITH_TECH_PASS_REQUEST";
export const COMPLETE_OPERATION_WITH_TECH_PASS_WEIGHT_SUCCESS =
  "COMPLETE_OPERATION_WITH_TECH_PASS_SUCCESS";
export const COMPLETE_OPERATION_WITH_TECH_PASS_WEIGHT_FAIL =
  "COMPLETE_OPERATION_WITH_TECH_PASS_FAIL";

export const ADD_SUB_ORDER_FAIL = "ADD_SUB_ORDER_FAIL";
export const ADD_SUB_ORDER_REQUEST = "ADD_SUB_ORDER_REQUEST";
export const ADD_SUB_ORDER_SUCCESS = "ADD_SUB_ORDER_SUCCESS";
export const DELETE_SUB_ORDER_FAIL = "DELETE_SUB_ORDER_FAIL";
export const DELETE_SUB_ORDER_REQUEST = "DELETE_SUB_ORDER_REQUEST";
export const DELETE_SUB_ORDER_SUCCESS = "DELETE_SUB_ORDER_SUCCESS";
export const GET_SINGLE_SUB_ORDER_FAIL = "GET_SINGLE_SUB_ORDER_FAIL";
export const GET_SINGLE_SUB_ORDER_REQUEST = "GET_SINGLE_SUB_ORDER_REQUEST";
export const GET_SINGLE_SUB_ORDER_SUCCESS = "GET_SINGLE_SUB_ORDER_SUCCESS";
export const GET_SUB_ORDER_LIST_FAIL = "GET_SUB_ORDER_LIST_FAIL";
export const GET_SUB_ORDER_LIST_REQUEST = "GET_SUB_ORDER_LIST_REQUEST";
export const GET_SUB_ORDER_LIST_SUCCESS = "GET_SUB_ORDER_LIST_SUCCESS";
export const UPDATE_SUB_ORDER_FAIL = "UPDATE_SUB_ORDER_FAIL";
export const UPDATE_SUB_ORDER_REQUEST = "UPDATE_SUB_ORDER_REQUEST";
export const UPDATE_SUB_ORDER_SUCCESS = "UPDATE_SUB_ORDER_SUCCESS";
